export const tooltipMap = {
  emotions: {
    criticism: 'The expression of disapproval of someone or something based on perceived faults or mistakes.',
    frustration: 'A feeling of annoyance or impatience resulting from being unable to achieve something.',
    confusion: "A state of being bewildered or unclear in one's mind about something.",
    disappointment: "A feeling of sadness or displeasure caused by the non-fulfillment of one's hopes or expectations.",
    thankfulness: 'The feeling of gratitude or appreciation for something received or experienced.',
    anger: 'A strong feeling of annoyance, displeasure, or hostility.',
    disapproval: 'The feeling of not approving or disagreeing with something.',
    concern: 'A feeling of worry or anxiety about something or someone.',
    hate: 'An intense feeling of aversion or hostility towards someone or something.',
    satisfaction:
      "A feeling of contentment or pleasure resulting from the fulfillment of one's wishes, expectations, or needs.",
    sexual_desire: 'A strong feeling of wanting to engage in sexual activity.',
    annoyance: 'A feeling of slight irritation or impatience.',
    appreciation: 'The recognition and enjoyment of the good qualities of someone or something.',
    sadness: 'A feeling of sorrow or unhappiness.',
    regret: 'A feeling of sadness, repentance, or disappointment over something that has happened or been done.',
    uncertainty: 'The state of being unsure or not having certain knowledge about something.',
    violence: 'The use of physical force to harm, abuse, damage, or destroy.',
    disgust: 'A feeling of revulsion or strong disapproval aroused by something unpleasant or offensive.',
    anxiety:
      'A feeling of worry, nervousness, or unease, typically about an imminent event or something with an uncertain outcome.',
  },
  sentiment: {
    very_negative:
      'When the user uses highly explicit negative terms or expresses a strongly opinionated negative view.',
    negative: 'When the user is irritated, complaining, or mildly insulting the assistant.',
    neutral: 'No discernible sentiment is detected.',
    mixed: 'Both positive and negative sentiments are expressed in the interaction.',
    positive: 'When the user praises something, either implicitly or explicitly.',
    very_positive: 'When the user is enthusiastic about something.',
  },
} as { emotions: { [key: string]: string }; sentiment: { [key: string]: string } };
